import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import { getMerchant } from 'Store/selectors';
import * as actionLayer from '../../modules/MerchantActions';
import DeleteMerchantPopup from './DeleteMerchantPopup';

const mapDispatchToProps = (dispatch) => ({
	deleteMerchant: (merchantId) =>
		dispatch(
			actionLayer.deleteMerchant.request({
				...merchantId,
			})
		),
	closeModal: () => dispatch(goPopup('')),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => getMerchant(state, 'isLoading'), false),
	payload: nullSafe(() => portalModalSelector(state).data.payload, false),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(DeleteMerchantPopup);
